import React from "react";

interface AuditLogJsonPopoverProps {
  jsonPopover: any;
  popoverPos: {x: number; y: number};
}

export const AuditLogJsonPopover = ({
  jsonPopover,
  popoverPos
}: AuditLogJsonPopoverProps) => {
  if (!jsonPopover) {
    return null;
  }

  return (
    <div
      className='fixed z-[99999] overflow-auto rounded-lg shadow-xl bg-gray-900 text-white text-xs p-3'
      style={{
        left: popoverPos.x - 300,
        top: popoverPos.y + 12,
      }}
    >
      <pre className='whitespace-pre'>
        {JSON.stringify(jsonPopover, null, 2)}
      </pre>
    </div>
  );
};
